import 'leaflet';
import 'leaflet.awesome-markers';

import 'leaflet/dist/leaflet.css';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import 'font-awesome/css/font-awesome.min.css';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import {world} from './countries.geo.js';

import '../styles/index.css';

((
    ($) => {

        $(document).ready(function () {

            const mapElementId = 'projects-map';

            let osmUrl = `https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.{ext}`;
            let osmAttrib = 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

            let osm = L.tileLayer(osmUrl, {
                minZoom: 0,
                maxZoom: 20,
                ext: 'png',
                attribution: osmAttrib
            });

            let map = new L.Map(mapElementId, {
                layers: [osm],
                center: [-0.17578097424708533, -14.150390625000002],
                zoom: 3,
                scrollWheelZoom: false,
                keyboard: false,
                zoomControl: false,
                doubleClickZoom: false,
                dragging: false,
            });

            const style = {
                fillColor: '#2a5298',
                weight: 1,
                opacity: 1,
                color: '#2a5298',
                fillOpacity: 0.5
            };

            const style_active = {
                fillColor: '#cc32ca',
                weight: 1,
                opacity: 1,
                color: '#cc32ca',
                fillOpacity: 0.5
            };

            const _selected_countries = [];
            $(world.features).each(function (index, feature) {
                if (jQuery.inArray(feature.id, application.translations.selectedCountires) !== -1) {
                    _selected_countries.push(feature);
                }
            });

            var myGeojSonLayerGroup = L.geoJson(_selected_countries, {
                // onEachFeature: myOnEachFeature,
                style: style
            }).addTo(map);

            map.fitBounds(myGeojSonLayerGroup.getBounds());

            $('.map-project').each(function (index, project) {
                const _layers = [];
                const countries = $(project).data('country-id').split(',');

                map.eachLayer(function (layer) {
                    if (layer.feature != undefined && layer.feature.id != undefined) {
                        if (countries.includes(layer.feature.id)) {
                            _layers.push(layer);
                        }
                    }
                });

                $(project).data("country-layer", _layers);
            });

            $(".map-project").hover(function () {
                var item = $(this);
                if (item.data("country-layer").length) {
                    myGeojSonLayerGroup.resetStyle(myGeojSonLayerGroup);
                    const _bounds = [];
                    $(item.data("country-layer")).each(function (index, layer) {
                        layer.setStyle(style_active);
                        _bounds.push(layer._bounds);
                    })
                    map.fitBounds(_bounds);
                }
            }, function () {
                var item = $(this);
                if (item.data("country-layer").length) {
                    myGeojSonLayerGroup.resetStyle(myGeojSonLayerGroup);
                    $(item.data("country-layer")).each(function (index, layer) {
                        layer.setStyle(style);
                    })
                    map.fitBounds(myGeojSonLayerGroup.getBounds());
                }
            });

            // const myOnEachFeatureLayers = [];
            //
            // function myOnEachFeature(feature, layer) {
            //     const myOnEachFeatureLayers = [];
            //
            //     const item = $('.map-project');
            //     item.each(function (index, project) {
            //         console.log(myOnEachFeatureLayers,$(project).data('id'))
            //         const countries = $(project).data('country-id').split(',');
            //         // if (countries.includes(feature.id)) {
            //         //     myOnEachFeatureLayers[$(project).data('id')].push(layer);
            //         // }
            //         // $(project).data("country-layer", myOnEachFeatureLayers[$(project).data('id')]);
            //     });
            // }
        })
    }
)
(jQuery));